/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Today's date on the gym's calendar, kept current on a tab left open across gym
 * midnight or woken from sleep. Null while the zone is unknown.
 */
import { useEffect, useState } from "react";
import { calendarDateKey } from "@lemonadetraining/contracts";

const REFRESH_MS = 60 * 1000;

const readKey = (zone: string | null) => (zone ? calendarDateKey(Date.now(), zone) : null);

export function useGymTodayKey(zone: string | null): string | null {
  const [state, setState] = useState(() => ({ zone, key: readKey(zone) }));

  useEffect(() => {
    const refresh = () => {
      const key = readKey(zone);
      setState((prev) => (prev.zone === zone && prev.key === key ? prev : { zone, key }));
    };
    const onVisibility = () => {
      if (document.visibilityState === "visible") refresh();
    };
    refresh();
    const timer = setInterval(refresh, REFRESH_MS);
    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("focus", refresh);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", refresh);
    };
  }, [zone]);

  return state.zone === zone ? state.key : readKey(zone);
}
